

import axiosClient from "./axiosClient";

const locationServiceApi = {

    getByCountryId: (params) =>{
        const url = `api/locationService/getByCountry/${params}`
        return axiosClient.get(url,params)
    },

    getById: (params, language) =>{
        const url = `api/locationService/${params}/${language}`
        return axiosClient.get(url,params, language)
    },

    getAll: (body) =>{
        const url = `api/locationService/getall`
        return axiosClient.post(url, body)
    },

    createlocationService: (params) =>{
        const url = `api/locationService/create`
        return axiosClient.post(url,params, {
            useAuthorize: true
        })
    },

    
    updatelocationService: (params,data) =>{
        const url = `api/locationService/${params}`
        return axiosClient.put(url,data, {
            useAuthorize: true
        })
    },
    
    calculateCoord: (data) =>{
        const url = `api/calculate`
        return axiosClient.post(url,data)
    },
    deleteLocationServiceById: (params) =>{
        const url = `api/locationService/${params}`
        return axiosClient.delete(url, {
            useAuthorize: true
        })
    }

}
export default locationServiceApi;